// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductSelectQueryVariables = Types.Exact<{
  filter: Types.ProductFilter;
  first: Types.Scalars['Int']['input'];
}>;


export type ProductSelectQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', sku?: string | null | undefined, upc?: string | null | undefined, id: string, name: string }> };

export type ProductSelect_ProductFragment = { __typename?: 'Product', sku?: string | null | undefined, upc?: string | null | undefined, id: string, name: string };

export const ProductSelect_ProductFragmentDoc = gql`
    fragment ProductSelect_Product on Product {
  ...Named
  sku
  upc
}
    ${NamedFragmentDoc}`;
export const ProductSelectDocument = gql`
    query ProductSelect($filter: ProductFilter!, $first: Int!) {
  products(filter: $filter, first: $first) {
    ...ProductSelect_Product
  }
}
    ${ProductSelect_ProductFragmentDoc}`;

/**
 * __useProductSelectQuery__
 *
 * To run a query within a React component, call `useProductSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSelectQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useProductSelectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductSelectQuery, ProductSelectQueryVariables> & ({ variables: ProductSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductSelectQuery, ProductSelectQueryVariables>(ProductSelectDocument, options);
      }
export function useProductSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductSelectQuery, ProductSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductSelectQuery, ProductSelectQueryVariables>(ProductSelectDocument, options);
        }
// @ts-ignore
export function useProductSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductSelectQuery, ProductSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductSelectQuery, ProductSelectQueryVariables>;
export function useProductSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductSelectQuery, ProductSelectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductSelectQuery | undefined, ProductSelectQueryVariables>;
export function useProductSelectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductSelectQuery, ProductSelectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductSelectQuery, ProductSelectQueryVariables>(ProductSelectDocument, options);
        }
export type ProductSelectQueryHookResult = ReturnType<typeof useProductSelectQuery>;
export type ProductSelectLazyQueryHookResult = ReturnType<typeof useProductSelectLazyQuery>;
export type ProductSelectSuspenseQueryHookResult = ReturnType<typeof useProductSelectSuspenseQuery>;
export type ProductSelectQueryResult = Apollo.QueryResult<ProductSelectQuery, ProductSelectQueryVariables>;